// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCjN2oG1xoIyKNnwH1zy3RFz-gYn5hhJac",
  authDomain: "familytrackerapp-83ad3.firebaseapp.com",
  databaseURL: "https://familytrackerapp-83ad3-default-rtdb.firebaseio.com",
  projectId: "familytrackerapp-83ad3",
  storageBucket: "familytrackerapp-83ad3.firebasestorage.app",
  messagingSenderId: "590537628553",
  appId: "1:590537628553:web:034d9a1497309b298b9f58",
  measurementId: "G-483PJVNEQC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics only in browser environment
let analytics = null;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

export { app, analytics };

